export default __webpack_public_path__ + "static/media/continent.bd41fbe2.svg";